import { render, staticRenderFns } from "./StatisticsTradersFilters.vue?vue&type=template&id=fad1426a&scoped=true&"
import script from "./StatisticsTradersFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradersFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradersFilters.vue?vue&type=style&index=0&id=fad1426a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad1426a",
  null
  
)

export default component.exports